export default __webpack_public_path__ + "static/media/down-arrow.583c7e0b.svg";